export function getEaster(Y: number) {
  let M = 0;
  let N = 0;
  let day;
  let month;

  if (Y < 2099) {
    M = 24;
    N = 5;
  } else if (Y < 2199) {
    M = 24;
    N = 6;
  } else if (Y < 2299) {
    M = 25;
    N = 0;
  } else if (Y < 2399) {
    M = 26;
    N = 1;
  } else if (Y < 2499) {
    M = 25;
    N = 1;
  }

  const a = Y % 19;
  const b = Y % 4;
  const c = Y % 7;
  const d = (19 * a + M) % 30;
  const e = (2 * b + 4 * c + 6 * d + N) % 7;

  if (d + e < 10) {
    day = d + e + 22;
    month = 3;
  } else {
    day = d + e - 9;
    month = 4;
  }

  if (day == 26 && month == 4) {
    day = 19;
    month = 4;
  }

  if (day == 25 && month == 4 && d == 28 && e == 6 && a > 10) {
    day = 18;
    month = 4;
  }

  return [String(month), String(day)].join('-');
}
